import { Redirect } from 'expo-router';

import SimulateTransaction from '../../../../banking/components/transaction-simulation/SimulateTransaction';
import { IS_PRODUCTION } from '../../../../config/FruitfulEnvironment';

const SimulateTransactionScreen = () => {
    if (IS_PRODUCTION) {
        return <Redirect href="/home/banking" />;
    }

    return <SimulateTransaction />;
};

export default SimulateTransactionScreen;
